import type * as lazyIndex from "./lazyIndex";
import { LazyModule, createLazyComponent, LazyAction, registerLazyOrchestrator, } from "owa-bundling";
import { getStore } from "./store/store";
import { searchFoldersFetchCompleted } from "owa-folders";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/*webpackChunkName: "MailSearchFolderView"*/ "./lazyIndex"), { name: "MailSearchFolderView" });

registerLazyOrchestrator(searchFoldersFetchCompleted, lazyModule, m => m.detectExpiredSearchFoldersOrchestrator);

// Export lazy components
export const LazyCreateSearchFolderModal: typeof lazyIndex.CreateSearchFolderModal = createLazyComponent(lazyModule, m => m.CreateSearchFolderModal, undefined, undefined, {
    onlyImportIf: () => getStore().isOpen,
});

// Export lazy actions
export const lazyEditSearchFolder: LazyAction<typeof lazyIndex.editSearchFolder, typeof lazyModule> = new LazyAction(lazyModule, m => m.editSearchFolder);
export const lazyReactivateExpiredSearchFolder: LazyAction<typeof lazyIndex.reactivateExpiredSearchFolder, typeof lazyModule> = new LazyAction(lazyModule, m => m.reactivateExpiredSearchFolder);
